import { createContext } from "react";

import { noop } from "lodash";

export type JumpToContextType = {
	onClose(): void;
};

export const JumpToContext = createContext<JumpToContextType>({
	onClose: noop,
});
